var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu__item"},[_c('span',{staticClass:"menu_link text-primary-color",on:{"click":function($event){return _vm.handleRedirect(_vm.item)}}},[_vm._v(" "+_vm._s(_vm.item.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }